<template>
    <div class="uep-comments-list max-w-3xl mx-auto" :class="{'with-user' : value}">
        <!-- Title & sort container -->
        <div class="comment-title">
            <h4 class="text-black">{{$t('worksapce.titles.comments')}}</h4>
            <div class="refresh-buton" :title="$t('worksapce.titles.refresh')" @click="refreshCommentsList"></div>
            <b-dropdown id="ddown-sort-comments" text="" class="text-sm sort-model">
                <b-dropdown-item @click="sortCommentsAsc">
                    <div class="icon asc"></div> {{$t('worksapce.buttons.sort-asc')}}
                </b-dropdown-item>
                <b-dropdown-item @click="sortCommentsDesc">
                    <div class="icon desc"></div> {{$t('worksapce.buttons.sort-desc')}}
                </b-dropdown-item>
            </b-dropdown>
        </div><!-- /Title & sort container -->
        <!-- Comment list container -->
        <div id="comments-list" class="comments-list">
            <comment v-for="(comment, index) in commentsList"
                     :key="comment.id"
                     :comment="comment"
                     :class="[index === commentsList.length - 1 ? '' : 'mb-6']">
            </comment>
        </div><!-- /Comment list container -->
        <!-- Add comment field container -->
        <div class="comment-field-container" v-shortkey="['enter']" @shortkey="saveComment()">

            <textarea v-model="body"
                      :placeholder="$t('worksapce.placeholder.write-something')"
                      class="comment-field"
                      :class="[state === 'editing' ? 'h-24' : 'h-10']"
                      ref="commentField"
                      @focus="startEditing">
            </textarea>
          <b-form-input v-if="value"
                        ref="commentFieldUserName"
                        v-model="name"
                        style="border-radius: 0!important"
                        :placeholder="$t('worksapce.placeholder.your_name')"
                        class="highlight__text"
          ></b-form-input>
            <button class="btn  btn-add-comment" @click="saveComment">{{$t('worksapce.buttons.add-comment')}}</button>
        </div><!-- /Add comment field container -->
    </div>
</template>

<script>
    import {HTTP} from '../../core/http/http-common';
    import Routing from '../../core/router/router';
    import comment from './UepCommentItem.vue';
    import store from '../../store/index_simple';
    import { mapGetters, mapActions } from 'vuex';
    import helper from '../../mixins/helper';
    import en from '../../i18n/en_US';
    import fr from '../../i18n/fr_FR';

    export default {
        name: "uep-comments-list",
        components: { comment },
        props: ['value'],
        i18n: {
            messages: {
                en: en,
                fr: fr
            }
        },
        mixins: [helper],
        data () {
            return {
                state: 'default',
                body: '',
                name:null
            }
        },
        watch: {
            videoId (newVal) {
                this.getCommentsApi(newVal);
            }
        },
        mounted () {
            this.getCommentsApi(this.videoId)
        },
        computed: {
            /**
             * Getters from Vuex Store
             */
            ...mapGetters({
                commentsList: 'getComments',
                videoId: 'getVideoId',
                mediaId: 'getMediaId',
                clientId: 'getClient',
                currentUser: 'getCurrentUser',
            }),
        },
        beforeCreate() {
            this.$store = store;
        },
        created(){
          if(this.$cookie.get('uepUserName')){
            this.name = this.$cookie.get('uepUserName');
            this.setUserName({name : this.$cookie.get('uepUserName')})
          }else if(!!!value){
            this.name = this.currentUser.name
          }

        },
        methods: {
            /**
             * Actions from Vuex Store
             */
            ...mapActions([
                'addComment',
                'sortCommentsAsc',
                'sortCommentsDesc',
                'updateCommentsList',
                'setUserName'
            ]),
            /**
             * Enable the edit mode (show textarea and edit buttons)
             *
             * @function    startEditing
             */
            startEditing() {
                this.state = 'editing';
            },
            /**
             * Disable the edit mode (hide textarea and edit buttons)
             *
             * @function    stopEditing
             */
            stopEditing() {
                this.state = 'default';
                this.body = '';
            },
            /**
             * Refresh the cmment list content
             *
             * @function    refreshCommentsList
             */
            refreshCommentsList () {
                this.getCommentsApi(this.videoId);
            },
            /**
             * Add comment to the list
             *
             * @function    saveComment
             */
            saveComment() {
                if(this.name && this.value){
                  if(this.value){
                    this.$cookie.set('uepUserName',this.name)
                    this.setUserName({name : this.$cookie.get('uepUserName')})
                  }
                  if (this.body) {
                    console.log(this.body);
                    let newComment = {
                      body: this.body,
                      edited: false,
                      status: true,
                      created_at: new Date(),
                      author: {
                        id: this.currentUser.id,
                        name: this.currentUser.name,
                      }
                    };
                    /* persit the comment in DB */
                    this.postCommentsApi(this.videoId, newComment);
                    this.stopEditing();
                  }

                  this.$refs.commentField.focus();
                }else{
                  this.$refs.commentFieldUserName.focus();
                }

            },
            /**
             * Set replies from API to the store
             *
             * @function    _alignRepliesWithAPI
             *
             * @param       repliesAPI
             */
            _alignRepliesWithAPI (repliesAPI) {
                let replies = [];
                repliesAPI.forEach(function (replyApi) {
                    replies.push({
                        body: replyApi.comment,
                        edited: false,
                        created_at: new Date(replyApi.date),
                        author: {
                            id: replyApi.user.split(';')[0],
                            name: replyApi.user.split(';')[1],
                        }
                    });
                });
                return replies;
            },
            /**
             * Set comments from API to the store
             *
             * @function    _alignCommentsWithAPI
             *
             * @param       commentsAPI
             */
            _alignCommentsWithAPI (commentsAPI) {
                let self = this;
                let replies = [];
                commentsAPI.forEach(function (commentApi) {
                    replies = [];
                    if (commentApi.commentsChilds.length > 0) {
                        replies = self._alignRepliesWithAPI(commentApi.commentsChilds);
                    }
                    let commentObject = {
                        id: commentApi.id,
                        body: commentApi.comment,
                        edited: false,
                        status: commentApi.status,
                        created_at: new Date(commentApi.date),
                        responses: replies
                    };
                    if (commentApi.user != undefined) {
                        commentObject.author = {
                            id: commentApi.user.split(';')[0],
                            name: commentApi.user.split(';')[1],
                        };
                    }
                    self.addComment(commentObject);
                });
            },
            /**
             * Get the stored comment by video id
             *
             * @function    getCommentsApi
             *
             * @param       videoId
             */
            getCommentsApi (videoId) {
                if (videoId !== 0) {
                    let self = this;
                    HTTP.get(Routing.generate("api_media_get_comment_media_by_video", {id: videoId, client: this.clientId}))
                        .then(function (response) {
                            if (response.data.code === 200) {
                                if (response.data.message !== "no_comment_for_this_video") {
                                    self._alignCommentsWithAPI(response.data.data[0].comments);
                                    self.sortCommentsDesc();
                                    self.animateScroll(100, '#comments-list');
                                }
                            }
                        }, function (response) {
                            console.log('api error' + response);
                          eventHub.$emit('error',{code: response.code, cause: response.message})
                        });
                }
            },
            /**
             * Post the comment (store in the DB)
             *
             * @function    postCommentsApi
             *
             * @param       videoId
             * @param       comment
             */
            postCommentsApi (videoId, comment) {
                let self = this;
                let params = {
                    empMediaCommentsForm:{
                        comment: comment.body, parent: '',
                        user: this.currentUser.id + ';' + this.currentUser.name,
                        email: this.currentUser.email,
                        media: this.mediaId
                    }
                };
                HTTP.post(Routing.generate("api_media_post_add_comments", {client: this.clientId}), params, {emulateJSON: true})
                    .then(function (response) {

                        if (response.data.code === 200) {
                          console.log(self.videoId);
                            /* get all stored comments and add them to vuex store */
                            self.getCommentsApi(self.videoId);
                        }
                    }, function (response) {
                        console.log('api error' + response);
                      eventHub.$emit('error',{code: response.code, cause: response.message})
                    });
            }
        }
    }
</script>

<style lang="scss">
    @import "../../assets/scss/workspace/_commentsList.scss";
    @import "../../assets/scss/sous-titrage/_sousTitragePlayer.scss";

</style>



// WEBPACK FOOTER //
// src/components/workspaceComponents/UepCommentsList.vue